import React, { Component } from "react";
import { Subscribe } from "unstated";
import inView from "in-view";
import styled from "styled-components";
import { withRouter } from "react-router-dom"

import { scrollTo } from "../utils";
import Layout from "./Layout";
import ElementWrapper from "./ElementWrapper";
import AppStateContainer from "../AppStateContainer";
import Pagination from "./Pagination";

class ElementsPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loaded: false
    };

    this.props.history.listen(() => {
      window.scrollTo({ top: 0 });
    });
  }

  componentDidMount() {
    ElementsPage._handleInViewElements();
    const { hash } = this.props.location;
    if (!hash) return;
    const el = document.getElementById(hash.split('#')[1]);
    scrollTo(el);
  }

  static _handleInViewElements() {
    inView(".element-frame").on("enter", el => {
      if (el.src === "") {
        el.src = el.dataset.src;
      }
    });
  }

  maybeResetLoadedState(app) {
    // local state required to avoid infinite renders
    // if (this.state.loaded) {
    //   return;
    // }

    // app.resetLoadedState();
    // this.setState({ loaded: true });
  }

  render() {
    const { categoryIdx } = this.props;

    return (
      <Subscribe to={[AppStateContainer]}>
        {app => {
          const category = app.state.categories[categoryIdx];
          this.maybeResetLoadedState(app);
          return (
            <>
              <Layout>
                <PageTitle>{category.titleLong}</PageTitle>
                {category.items.map((item, idx) => (
                  <ElementWrapper
                    key={idx}
                    idx={idx}
                    category={category}
                    categoryIdx={categoryIdx}
                    element={item}
                    state={app}
                  />
                ))}
              </Layout>
              <Pagination catIdx={categoryIdx} />
            </>
          );
        }}
      </Subscribe>
    );
  }
}

export default withRouter(ElementsPage);

const PageTitle = styled.h2`
  text-align: center;
  font-size: 30px;
  margin-bottom: 50px;
`;
